import React from "react";

export default function ConfirmModal({ message, onConfirm, onCancel }) {
	return (
		<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
			<div className="bg-white rounded-lg shadow-lg p-6 w-96">
				<h2 className="text-lg font-bold text-center mb-4">Conferma</h2>
				<p className="text-gray-700 text-center mb-6">{message}</p>
				<div className="flex justify-center space-x-4">
					<button
						id="confirm"
						aria-label="Conferma"
						className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 transition"
						onClick={onConfirm}
					>
						Conferma
					</button>
					<button
						id="cancel"
						aria-label="Annulla"
						className="bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400 transition"
						onClick={onCancel}
					>
						Annulla
					</button>
				</div>
			</div>
		</div>
	);
}
